import SEO from "@/components/SEO";
import { FadeUp, SectionTag, MaskedLines } from "@/components/Reveal";
import { CONTACT } from "@/data/content";

const Block = ({ title, children, id }) => (
  <FadeUp>
    <section data-testid={id} className="border-b border-sand/70 py-10">
      <h2 className="font-serif text-2xl">{title}</h2>
      <div className="mt-4 space-y-3 leading-relaxed text-stone">{children}</div>
    </section>
  </FadeUp>
);

const Datenschutz = () => (
  <div data-testid="datenschutz-page">
    <SEO
      title="Datenschutzerklärung | Daviz & Puxi – Freie Trauung Deluxe"
      description="Datenschutzerklärung von Freie Trauung Deluxe – Marc Hofmeister, Krefeld. Informationen zum Umgang mit personenbezogenen Daten gemäß DSGVO."
      path="/datenschutz"
    />
    <section className="mx-auto max-w-3xl px-5 pb-24 pt-36 sm:px-8 sm:pt-44">
      <FadeUp>
        <SectionTag>Rechtliches</SectionTag>
      </FadeUp>
      <MaskedLines lines={["Datenschutz"]} className="mt-6 font-serif text-5xl sm:text-7xl" delay={0.15} />
      <FadeUp delay={0.3}>
        <p className="mt-8 text-lg leading-relaxed text-stone">
          Der Schutz Ihrer persönlichen Daten ist uns wichtig. Nachfolgend informieren wir Sie
          darüber, welche Daten beim Besuch dieser Website verarbeitet werden und welche Rechte
          Ihnen zustehen.
        </p>
      </FadeUp>

      <div className="mt-10">
        <Block title="1. Verantwortlicher" id="ds-verantwortlicher">
          <p>
            Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:
          </p>
          <p>
            Marc Hofmeister<br />
            Freie Trauung Deluxe – Mark Daviz & Angela Puxi<br />
            Pottbäckerstr. 17<br />
            47839 Krefeld<br />
            Mobil: +49 (0) 171 534 01 05<br />
            E-Mail: {CONTACT.email}
          </p>
        </Block>

        <Block title="2. Allgemeine Hinweise zur Datenverarbeitung" id="ds-allgemein">
          <p>
            Wir verarbeiten personenbezogene Daten nur, soweit dies zur Bereitstellung dieser
            Website, zur Beantwortung Ihrer Anfragen oder aufgrund gesetzlicher Pflichten
            erforderlich ist. Rechtsgrundlagen sind insbesondere Art. 6 Abs. 1 lit. a DSGVO
            (Einwilligung), Art. 6 Abs. 1 lit. b DSGVO (Vertrag bzw. vorvertragliche Maßnahmen)
            und Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse am sicheren und stabilen
            Betrieb dieser Website).
          </p>
          <p>
            Personenbezogene Daten sind alle Informationen, die sich auf eine identifizierte oder
            identifizierbare natürliche Person beziehen – z. B. Name, E-Mail-Adresse oder
            Telefonnummer.
          </p>
        </Block>

        <Block title="3. Hosting und Server-Logfiles" id="ds-hosting">
          <p>
            Diese Website wird bei einem externen Dienstleister gehostet (Hostinger International
            Ltd., Zypern). Beim Aufruf der Website werden durch den Hosting-Anbieter automatisch
            Informationen in sogenannten Server-Logfiles erfasst, insbesondere:
          </p>
          <p>
            IP-Adresse, Datum und Uhrzeit des Zugriffs, aufgerufene Seite, Referrer-URL,
            verwendeter Browser und Betriebssystem.
          </p>
          <p>
            Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Unser
            berechtigtes Interesse liegt in der technisch fehlerfreien Darstellung und der
            Sicherheit der Website. Mit dem Hosting-Anbieter besteht ein Vertrag über
            Auftragsverarbeitung gemäß Art. 28 DSGVO.
          </p>
        </Block>

        <Block title="4. Kontaktaufnahme per E-Mail oder Telefon" id="ds-kontakt">
          <p>
            Wenn Sie uns per E-Mail, Telefon, WhatsApp oder über das Kontaktformular auf dieser
            Website kontaktieren, verarbeiten wir die von Ihnen mitgeteilten Daten (z. B. Name,
            E-Mail-Adresse, Telefonnummer, Wunschtermin, Inhalt Ihrer Nachricht und Angaben zu
            Ihrem Anlass), um Ihre Anfrage zu bearbeiten und für den Fall von Anschlussfragen.
          </p>
          <p>
            Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen bzw.
            Vertragserfüllung). Die Daten werden gelöscht, sobald sie für die Bearbeitung nicht
            mehr erforderlich sind und keine gesetzlichen Aufbewahrungspflichten bestehen.
            Eine Weitergabe an Dritte erfolgt nicht ohne Ihre Einwilligung.
          </p>
        </Block>

        <Block title="5. Cookies und lokale Speicherung" id="ds-cookies">
          <p>
            Diese Website verwendet keine Marketing-, Analyse- oder Tracking-Cookies und keinerlei
            Analyse- bzw. Tracking-Werkzeuge. Es können lediglich technisch notwendige Einträge im
            lokalen Speicher Ihres Browsers (Local Storage) entstehen, die der reibungslosen
            Darstellung der Website dienen. Diese Daten werden nicht an Dritte übertragen und nicht
            ausgewertet.
          </p>
        </Block>

        <Block title="6. Google Fonts" id="ds-fonts">
          <p>
            Zur einheitlichen und ansprechenden Darstellung der Schriftarten nutzt diese Website
            Schriftarten von Google Fonts (Anbieter: Google Ireland Limited, Gordon House, Barrow
            Street, Dublin 4, Irland). Beim Aufruf der Seite stellt Ihr Browser eine Verbindung zu
            den Servern von Google her, wobei insbesondere Ihre IP-Adresse an Google übermittelt
            wird.
          </p>
          <p>
            Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer
            einheitlichen Darstellung). Weitere Informationen finden Sie in der
            Datenschutzerklärung von Google: https://policies.google.com/privacy
          </p>
        </Block>

        <Block title="7. SSL- bzw. TLS-Verschlüsselung" id="ds-ssl">
          <p>
            Diese Website nutzt aus Sicherheitsgründen und zum Schutz der Übertragung
            vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte
            Verbindung erkennen Sie an „https://" in der Adresszeile Ihres Browsers.
          </p>
        </Block>

        <Block title="8. Ihre Rechte als betroffene Person" id="ds-rechte">
          <p>Sie haben jederzeit das Recht auf:</p>
          <p>
            Auskunft über Ihre bei uns gespeicherten Daten (Art. 15 DSGVO), Berichtigung
            unrichtiger Daten (Art. 16 DSGVO), Löschung Ihrer Daten (Art. 17 DSGVO),
            Einschränkung der Verarbeitung (Art. 18 DSGVO), Datenübertragbarkeit (Art. 20 DSGVO)
            sowie Widerspruch gegen die Verarbeitung (Art. 21 DSGVO).
          </p>
          <p>
            Eine erteilte Einwilligung können Sie jederzeit mit Wirkung für die Zukunft
            widerrufen. Wenden Sie sich hierzu einfach an die oben genannte Kontaktadresse.
          </p>
        </Block>

        <Block title="9. Beschwerderecht bei der Aufsichtsbehörde" id="ds-beschwerde">
          <p>
            Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die
            Verarbeitung Ihrer personenbezogenen Daten durch uns zu beschweren. Zuständig ist
            insbesondere die Landesbeauftragte für Datenschutz und Informationsfreiheit
            Nordrhein-Westfalen (LDI NRW), Kavalleriestr. 2-4, 40213 Düsseldorf.
          </p>
        </Block>

        <Block title="10. Aktualität dieser Datenschutzerklärung" id="ds-aktualitaet">
          <p>
            Diese Datenschutzerklärung hat den Stand September 2026. Durch die Weiterentwicklung
            dieser Website oder aufgrund geänderter gesetzlicher Vorgaben kann eine Anpassung
            erforderlich werden. Die jeweils aktuelle Fassung finden Sie jederzeit auf dieser
            Seite.
          </p>
        </Block>
      </div>
    </section>
  </div>
);

export default Datenschutz;
